import React, { useState, useRef, useEffect } from 'react';
import SideBar from '../../Components/Navbar/Sidebar';
import { toast, ToastContainer } from "react-toastify";
import { newsUpload } from '../../Components/Apis/apis';

const Uploadnews = () => {
  const [newsTitle, setNewsTitle] = useState('');
  const [newsUrl, setNewsUrl] = useState('');
  const [newsSummary, setNewsSummary] = useState('');
  const [newsImage, setNewsImage] = useState(null);
  const [newsFor, setNewsFor] = useState('gohoarding');
  const fileInputRef = useRef(null);

  const handleBoxClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setNewsImage(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newsImage && newsTitle && newsUrl && newsSummary ) {
      const formData = new FormData();
      formData.append('image', newsImage);
      formData.append('title', newsTitle);
      formData.append('url', newsUrl);
      formData.append('newsFor', newsFor);
      formData.append('summary', newsSummary);
   
      const data = await newsUpload(formData);
      if (data.success === true) {
        toast(data.message);
        setNewsTitle('');
        setNewsUrl('');
        setNewsImage(null);
        setNewsSummary('');
      } else {
        toast.error(data.message);
      }
    } else {
      alert("All fields required");
    }
  };

  return (
    <>
      <div className="containers">
        <div className="container-sidebar">
          <SideBar />
        </div>
        <div className="container-pages ">
          <div className="page-title">
            <h2>Upload News</h2>
          </div>

          <form onSubmit={handleSubmit}>
            <div className='row'>
              <div className='col-8'>
                <div className="form-group">
                  {/* Input field for news title */}
                  <label htmlFor="newsTitle">News Title:</label>
                  <input
                    type="text"
                    id="newsTitle"
                    className="form-control ms-0 mt-1"
                    value={newsTitle}
                    onChange={(e) => setNewsTitle(e.target.value)}
                    placeholder="Enter News Title"
                  />
                </div>

                <div className="form-group">
                  {/* Input field for news URL */}
                  <label htmlFor="newsUrl">News URL:</label>
                  <input
                    type="text"
                    id="newsUrl"
                    className="form-control ms-0 mt-1"
                    value={newsUrl}
                    onChange={(e) => setNewsUrl(e.target.value)}
                    placeholder="Enter News URL"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="newsSummary">Summary & Description:</label>
                  <textarea
                    id="newsSummary"
                    className="form-control ms-0 mt-1"
                    value={newsSummary}
                    onChange={(e) => setNewsSummary(e.target.value)}
                    rows={3}
                    placeholder="Enter News Summary"
                  />
                </div>

            
              </div>
              <div className='col-4 ps-5'>
              <div className="form-group">
    <label htmlFor="newsUrl">Blog For:</label>
    <select
        id="NewsUrl"
        className="form-select ms-0  w-75 mt-1"
        value={newsFor}
        onChange={(e) => setNewsFor(e.target.value)}
    >
        <option value="gohoarding" selected>Gohoarding</option>
        <option value="newgoh">New Goh</option>
        <option value="pghive">PG Hive</option>
        <option value="influencer">InfluencerSea</option>
    </select>
            </div>
                <div className="form-group mt-2">
                  <label htmlFor="newsImage">News Image:</label>
                  <div
                    className='image-upload-box mt-1'
                    onClick={handleBoxClick}
                  >
                    {newsImage && (
                      <img
                        src={URL.createObjectURL(newsImage)}
                        alt="News"
                        style={{ width: "180px", height: "120px" }}
                      />
                    )}
                    {!newsImage && (
                      <span>Click to select image</span>
                    )}
                  </div>
                  <input
                    type="file"
                    id="newsImage"
                    accept=".jpg, .png"
                    onChange={handleImageChange}
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                  />
                </div>
              </div>
            </div>

            <div className='col-12 text-center'>
              <div>
                {/* Submit button */}
                <button type="submit" className="btn btn-info text-light w-25 mt-3">Upload</button>
                <ToastContainer />
              </div>
            </div>

          </form>

        </div>
      </div>
    </>
  );
};

export default Uploadnews;
